import { Link } from 'react-router-dom';
import GallerySection from '../components/GallerySection';

export default function Privat() {
  // Optimeret billede til privatsiden
  const privatImg = 'https://assets.auxodev.dk/assets/e40be0c5-fb9a-4c6f-b41e-69a05bb6d2d7/672330188-1459533669298354-5069136850237555422-n.jpg';
  const optimizedImg = privatImg.replace('assets.auxodev.dk/assets/', 'assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/');

  return (
    <>
      {/* React 19 Native Metadata Hoisting */}
      <title>Privat Vinduespolering - Nygaards Vinduespolering</title>
      <meta
        name="description"
        content="Få rene vinduer i hjemmet med privat vinduespolering fra Nygaards Vinduespolering i Kerteminde og omegn."
      />

      {/* Hero Header */}
      <section className="bg-slate-50/70 py-20 border-b border-slate-100">
        <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
            Privatservice
          </span>
          <h1 className="mt-3 font-display text-3xl font-bold uppercase tracking-wider text-brand-blue sm:text-4xl">
            Privat Vinduespolering
          </h1>
          <div className="mx-auto mt-4 h-0.5 w-12 bg-brand-orange" />
          <p className="mx-auto mt-6 max-w-2xl text-sm font-light leading-relaxed text-slate-500">
            Skinnende rene vinduer i dit hjem, der lukker lyset ind og forbedrer dit indeklima og helhedsindtryk.
          </p>
        </div>
      </section>

      {/* Detaljeret Indhold */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-12 lg:items-center">
            {/* Tekst */}
            <div className="lg:col-span-7">
              <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
                Rene ruder
              </span>
              <h2 className="mt-2 font-display text-2xl font-bold uppercase tracking-wider text-brand-dark">
                Rene ruder og mere lys i hjemmet
              </h2>
              <p className="mt-6 text-sm font-light leading-relaxed text-slate-500">
                Der er intet som skinnende rene vinduer til at friske et hjem op. Hos Nygaards Vinduespolering pudser vi dine vinduer med stor omhu, uanset om du bor i et moderne parcelhus, en hyggelig villa, en lejlighed eller har et sommerhus, der skal gøres klar til sæsonen. Vi tilbyder både udvendig og indvendig pudsning efter aftale.
              </p>
              <p className="mt-4 text-sm font-light leading-relaxed text-slate-500">
                Vi tilpasser os dine behov og tilbyder service til:
              </p>
              <ul className="mt-4 grid grid-cols-1 gap-3 text-xs font-light text-slate-500 sm:grid-cols-2">
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Klassiske parcelhuse & villaer</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Lejligheder (alle etager)</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Sommerhuse i lokalområdet</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Udvendig & indvendig pudsning</span>
                </li>
                <li className="flex items-center gap-2.5">
                  <i className="fa-solid fa-circle-check text-brand-blue" />
                  <span>Aftørring af karme & rammer</span>
                </li>
              </ul>

              <div className="mt-8 flex flex-wrap gap-4">
                <Link
                  to="/kontakt"
                  className="rounded-full bg-brand-blue px-8 py-4 font-display text-xs font-bold uppercase tracking-[0.2em] text-white hover:bg-brand-orange transition-all duration-300 hover:scale-105"
                >
                  Få et tilbud på privat vinduespolering
                </Link>
              </div>
            </div>

            {/* Billede */}
            <div className="lg:col-span-5">
              <div className="relative aspect-4/3 overflow-hidden rounded-none bg-slate-100 shadow-none">
                <img
                  src={optimizedImg}
                  alt="Professionel privat vinduespolering af parcelhus"
                  className="h-full w-full object-cover rounded-none"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Metoder Sektion */}
      <section className="bg-slate-50/50 py-16 border-t border-slate-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
              Frit valg af metode
            </span>
            <h2 className="mt-2 font-display text-2xl font-bold uppercase tracking-wider text-brand-blue">
              Rentvandsanlæg eller traditionel polering?
            </h2>
            <div className="mx-auto mt-4 h-0.5 w-12 bg-brand-orange" />
            <p className="mt-4 text-sm font-light leading-relaxed text-slate-500">
              Hos Nygaards Vinduespolering bruger vi både moderne rentvandsanlæg og almindelig, traditionel vinduespolering. Som kunde har du fuld frihed til selv at vælge, hvilken metode du ønsker til dit hjem.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* Rentvandsanlæg */}
            <div className="bg-white p-8 border border-slate-100 shadow-sm flex flex-col justify-between">
              <div>
                <div className="flex h-12 w-12 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue mb-6">
                  <i className="fa-solid fa-droplet text-lg" />
                </div>
                <h3 className="font-display text-base font-bold uppercase tracking-wider text-brand-dark">
                  Rentvandsanlæg (Vask med ultra-rent vand)
                </h3>
                <p className="mt-4 text-xs font-light leading-relaxed text-slate-500">
                  Vores rentvandsanlæg renser vandet for kalk, mineraler og urenheder. Når vi vasker dine ruder med dette ultra-rene vand, efterlader det en stribefri overflade helt uden brug af kemikalier eller sæbe.
                </p>
                <ul className="mt-4 space-y-2 text-xs font-light text-slate-500">
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-brand-blue" />
                    <span>100% miljøvenligt og kemifrit</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-brand-blue" />
                    <span>Perfekt til svært tilgængelige vinduer i højden</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-brand-blue" />
                    <span>Rammer og karme vaskes altid med i prisen</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* Traditionel polering */}
            <div className="bg-white p-8 border border-slate-100 shadow-sm flex flex-col justify-between">
              <div>
                <div className="flex h-12 w-12 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue mb-6">
                  <i className="fa-solid fa-hand-sparkles text-lg" />
                </div>
                <h3 className="font-display text-base font-bold uppercase tracking-wider text-brand-dark">
                  Almindelig vinduespolering (Klassisk håndværk)
                </h3>
                <p className="mt-4 text-xs font-light leading-relaxed text-slate-500">
                  Den klassiske metode med professionel indsæbning, skraber og tørring med mikrofiberklud. Dette er det traditionelle håndværk, der sikrer et fuldstændig fejlfrit og krystalklart resultat.
                </p>
                <ul className="mt-4 space-y-2 text-xs font-light text-slate-500">
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-brand-blue" />
                    <span>Klassisk, krystalklar glans</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-brand-blue" />
                    <span>Ideelt til både indvendig og udvendig pudsning</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="fa-solid fa-check text-brand-blue" />
                    <span>Nænsom og præcis pudsning i detaljer</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Fokusområder */}
      <section className="bg-slate-50/70 py-20 border-t border-b border-slate-100">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
              Vores værdier
            </span>
            <h2 className="mt-2 font-display text-2xl font-bold uppercase tracking-wider text-brand-blue">
              En tryg og behagelig service i dit hjem
            </h2>
            <div className="mx-auto mt-4 h-0.5 w-12 bg-brand-orange" />
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
            <div className="rounded-none border border-slate-200 bg-white p-8 shadow-none">
              <div className="flex h-10 w-10 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue">
                <i className="fa-solid fa-sparkles" />
              </div>
              <h3 className="mt-6 font-display text-base font-bold uppercase tracking-wider text-brand-dark">Krystalklart resultat</h3>
              <p className="mt-3 text-xs font-light leading-relaxed text-slate-500">
                Vi fjerner alt skidt, pollen og trafikfilm, så dine vinduer fremstår helt krystalklare og uden striber.
              </p>
            </div>
            <div className="rounded-none border border-slate-200 bg-white p-8 shadow-none">
              <div className="flex h-10 w-10 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue">
                <i className="fa-solid fa-calendar-days" />
              </div>
              <h3 className="mt-6 font-display text-base font-bold uppercase tracking-wider text-brand-dark">Fleksible aftaler</h3>
              <p className="mt-3 text-xs font-light leading-relaxed text-slate-500">
                Vælg en fast abonnementsaftale (f.eks. hver 4., 8. eller 12. uge) eller ring til os, når behovet opstår.
              </p>
            </div>
            <div className="rounded-none border border-slate-200 bg-white p-8 shadow-none">
              <div className="flex h-10 w-10 items-center justify-center rounded-none bg-brand-light-blue text-brand-blue">
                <i className="fa-solid fa-user-shield" />
              </div>
              <h3 className="mt-6 font-display text-base font-bold uppercase tracking-wider text-brand-dark">Tryg & pæn service</h3>
              <p className="mt-3 text-xs font-light leading-relaxed text-slate-500">
                Vi passer godt på dit hjem og dine planter, tager skoene af indenfor og efterlader altid alt pænt og ryddeligt.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Galleri Sektion (Tilkoblet via slug) */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <GallerySection slug="privat-vinduespolering" />
        </div>
      </section>
    </>
  );
}
